<template>
  <Modal
    hide-close-button
    :title="title"
  >
    <div class="streem-dialog">
      <div
        class="row q-gutter-x-md items-center justify-center"
        name="buttons"
      >
        <BaseButton
          flat
          label="Back To Users"
          new-design
          @click="backToUsers"
        />
        <BaseButton
          color="secondary"
          label="View User Profile"
          new-design
          @click="viewUserProfile"
        />
        <BaseButton
          color="primary"
          label="Add Another User"
          new-design
          @click="addAnotherUser"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "UserAddedModal",
  components: {
    BaseButton,
    Modal,
  },
  props: {
    firstName: {
      type: String,
      default: "",
    },
    lastName: {
      type: String,
      default: "",
    },
    organisationName: {
      type: String,
      default: "",
    },
    existing: {
      type: Boolean,
    },
  },
  emits: ["backToUsers", "addAnotherUser", "viewUserProfile"],
  computed: {
    title() {
      if (this.existing) {
        return `Successfully added '${this.firstName} ${this.lastName}' to '${this.organisationName}'`;
      }

      return `Successfully created user '${this.firstName} ${this.lastName}'`;
    },
  },
  methods: {
    backToUsers() {
      this.$emit("backToUsers");
    },
    addAnotherUser() {
      this.$emit("addAnotherUser");
    },
    viewUserProfile() {
      this.$emit("viewUserProfile");
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);
}
</style>
